import React from 'react';

import { Chip } from '@mui/material';

interface Props {
  status: string;
}

export default function StatusChip({ status }: Props) {
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        ...(status === 'content-approved'
          ? { bgcolor: '#e8f5e9', color: '#2e7d32' }
          : { bgcolor: '#fff3e0', color: '#e65100' }),
      }}
    />
  );
}
